import {useState} from "react";

import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {Reservations} from "@/variants/index.js";

export const ReservationsTab = ({reservations}) => {
	const [tableParams, setTableParams] = useState({
		pagination: {
			current: 1,
			pageSize: 50,
		},
	});

	function handleTableChange(pagination, filters, sorter) {
		setTableParams({
			pagination,
			filters,
			...sorter,
		});
	}

	return (
		<AntdTable
			tableSize={"small"}
			scroll={300}
			data={reservations}
			pagination={tableParams.pagination}
			onChange={handleTableChange}
			columns={Reservations.getColumns(reservations)}
		/>
	);
};
